import { Box, Typography } from "@mui/material";
import { BalanceContainer } from "Components/Dashboard/BalanceWithPaymentActions/BalanceContainer";
import { MobileBalanceSkeleton } from "Components/Dashboard/BalanceWithPaymentActions/MobileBalance/Components/MobileBalanceSkeleton";
import { MobileCurrencyBalance } from "Components/Dashboard/BalanceWithPaymentActions/MobileBalance/Components/MobileCurrencyBalance";
import { PaymentActions } from "Components/Dashboard/BalanceWithPaymentActions/MobileBalance/Components/PaymentActions";
import { Resources, useResource } from "Translations/Resources";

const BalanceResources = Resources.Balance.BalanceContent;

export const MobileBalance = () => {
  const { t } = useResource();

  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center">
        <Typography
          variant="subtitle1"
          component="div"
          color="primary.contrastText"
        >
          {t(BalanceResources.Title)}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        textAlign="center"
        gap={6}
        pb={4}
      >
        <BalanceContainer
          renderBalances={MobileCurrencyBalance}
          renderActions={PaymentActions}
          renderLoading={MobileBalanceSkeleton}
          renderError={() => <MobileBalanceSkeleton isError />}
          colorVariant="light"
        />
      </Box>
    </Box>
  );
};
